unit UMatList;

interface

uses
  System.Contnrs, UMatModel, Js, UEssentialHelper;

type
  TMatList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    FOnError: TErrorEvent;
    function GetItem(i: Integer): TMatModel;
    procedure DoError(AMsg: string);
    procedure PropertyChanged;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetOnPropertyChanged(const Value: TCallback);
    procedure SetOnError(const Value: TErrorEvent);
  public
    constructor Create(LocalStorage: Boolean);
    function ArtNrExists(ArtNr: string): Boolean;
    function GetByArtNr(ArtNr: string): TMatModel;
    function GetByCode(Code: string): TMatModel;
    function GetByEan(Ean: string): TMatModel;
    function IndexOf(Value: string): Integer;
    function IndexOfArtNr(ArtNr: string): Integer;
    function IndexOfEan(Ean: string): Integer;
    function ToJson: string;
    procedure Add(item: TMatModel);
    procedure GetAll(url: string);
    procedure SetValues(json: string); overload;
    property Items[i: Integer]: TMatModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged
      write SetOnPropertyChanged;
    property OnError: TErrorEvent read FOnError write SetOnError;
  end;

implementation

uses
  System.SysUtils, WebLib.REST, WebLib.Controls, WebLib.Storage, WebLib.JSON;

{ TMatList }

procedure TMatList.Add(item: TMatModel);
var
  index: Integer;
begin
  if Self.ArtNrExists(item.ArtNr) then
  begin
    index := Self.IndexOfArtNr(item.ArtNr);
    Self.Items[index].GetValueFrom(item);
  end
  else
    inherited Add(item);
  TLocalStorage.SetValue('MatList', Self.ToJson);
end;

function TMatList.ArtNrExists(ArtNr: string): Boolean;
begin
  Result := Self.IndexOfArtNr(ArtNr) >= 0;
end;

constructor TMatList.Create(LocalStorage: Boolean);
var s: string;
begin
  inherited Create;
  Self.OnPropertyChanged := nil;
  Self.OnError := nil;
  if LocalStorage then begin
    s:=TLocalStorage.GetValue('MatList');
    if s<>'' then
      Self.SetValues(s);
  end;
end;

procedure TMatList.DoError(AMsg: string);
begin
  if Assigned(Self.OnError) then
    Self.OnError(Self, AMsg);
end;

procedure TMatList.GetAll(url: string);
var
  client: TRestClient;
  cmd: string;
  procedure Response(sender: TObject; aResponse: string);
  var
    jso: TJsObject;
  begin
    if aResponse <> '' then
      TLocalStorage.SetValue(cmd, aResponse)
    else
      aResponse := TLocalStorage.GetValue(cmd);
    if aResponse <> '' then
    begin
      jso := TJsJson.parseObject(aResponse);
      if jso['value'] <> nil then
        Self.SetValues(string(jso['value']));
      Self.PropertyChanged;
    end
    else
      Self.DoError('Verbindungsfehler: TMatList.GetAll');
  end;

  procedure ErrorHandler(sender: TObject; ARequest: TJSXMLHttpRequestRecord;
    Event: TJSEventRecord; var Handled: Boolean);
  begin
    Handled := true;
    Response(Self, '');
  end;

begin
  client := TRestClient.Create(nil);
  cmd := url + '/MatService/GetAll';
  client.OnResponse := Response;
  client.OnError := ErrorHandler;
  client.HttpsPost(url + '/MatService/GetAll', 'application/json');
end;

function TMatList.GetByArtNr(ArtNr: string): TMatModel;
var
  index: Integer;
begin
  index := Self.IndexOfArtNr(ArtNr);
  if index >= 0 then
    Result := Self.Items[index]
  else
    Result := nil;
end;

function TMatList.GetByCode(Code: string): TMatModel;
begin
  Result := Self.GetByEan(Code);
  if Result = nil then
    Result := Self.GetByArtNr(Code);
end;

function TMatList.GetByEan(Ean: string): TMatModel;
var
  index: Integer;
begin
  index := Self.IndexOfEan(Ean);
  if index >= 0 then
    Result := Self.Items[index]
  else
    Result := nil;
end;

function TMatList.GetItem(i: Integer): TMatModel;
begin
  Result := inherited GetItem(i) as TMatModel;
end;

function TMatList.IndexOf(Value: string): Integer;
var
  i: Integer;
  found: Boolean;
  s: string;
begin
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
  begin
    s := Self.Items[i].Bezeichnung;
    if i > 0 then
      s := s + ' [' + Self.Items[i].MeEinheit + ']';
    if s = Value then
      found := true
    else
      Inc(i);
  end;
  if found then
    Result := i
  else
    Result := -1;
end;

function TMatList.IndexOfArtNr(ArtNr: string): Integer;
var
  i: Integer;
  found: Boolean;
begin
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
    if Self.Items[i].ArtNr = ArtNr then
      found := true
    else
      Inc(i);
  if found then
    Result := i
  else
    Result := -1;
end;

function TMatList.IndexOfEan(Ean: string): Integer;
var
  i: Integer;
  found: Boolean;
begin
  i := 0;
  found := false;
  while not found and (i < Self.Count) do
    if Self.Items[i].Ean = Ean then
      found := true
    else
      Inc(i);
  if found then
    Result := i
  else
    Result := -1;
end;

procedure TMatList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TMatList.SetOnError(const Value: TErrorEvent);
begin
  FOnError := Value;
end;

procedure TMatList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TMatList.SetValues(obj: TJsObject);
var
  i, Count: Integer;
begin
  Self.Clear;
  if obj['Count'] <> nil then
  begin
    Count := StrToInt(string(obj['Count']));
    for i := 0 to Count - 1 do
      if obj['Item' + IntToStr(i)] <> nil then
        Self.Add(TMatModel.Create(string(obj['Item' + IntToStr(i)])));
  end;
end;

procedure TMatList.SetValues(json: string);
var
  obj: TJsObject;
begin
  obj := TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

function TMatList.ToJson: string;
var
  obj: TJsonObject;
  i: Integer;
begin
  obj := TJsonObject.Create;
  obj.AddPair('Count', IntToStr(Self.Count));
  for i := 0 to Self.Count - 1 do
    obj.AddPair('Item' + IntToStr(i), Self.Items[i].ToJson);
  Result:=obj.ToJSON;
  obj.Free;
end;

end.
